module.exports = __webpack_public_path__ + "img/dwicon.457642df.png";